import React, { createContext, useState, useEffect } from 'react';  
import { authAPI } from '../api/client';  
  
export const AuthContext = createContext();  
  
export const AuthProvider = ({ children }) => {  
  const [user, setUser] = useState(null);  
  const [loading, setLoading] = useState(true);  
  
  useEffect(() => {  
    checkAuth();  
  }, []);  
  
  const checkAuth = async () => {  
    try {  
      const token = localStorage.getItem('token');  
      if (token) {  
        const response = await authAPI.getCurrentUser();  
        setUser(response.data.user);  
      }  
    } catch (error) {  
      console.error('Auth check failed:', error);  
      localStorage.removeItem('token');  
      localStorage.removeItem('user');  
    } finally {  
      setLoading(false);  
    }  
  };  
  
  const login = (token, userData) => {  
    localStorage.setItem('token', token);  
    localStorage.setItem('user', JSON.stringify(userData));  
    setUser(userData);  
  };  
  
  const logout = () => {  
    localStorage.removeItem('token');  
    localStorage.removeItem('user');  
    setUser(null);  
  };  
  
  const updateCredits = (newCredits) => {  
    if (user) {  
      const updatedUser = { ...user, credits: newCredits };  
      setUser(updatedUser);  
      localStorage.setItem('user', JSON.stringify(updatedUser));  
    }  
  };  
  
  return (  
    <AuthContext.Provider value={{ user, loading, login, logout, updateCredits, checkAuth }}>  
      {children}  
    </AuthContext.Provider>  
  );  
};  

